import axios from 'axios';

const service = {
    storeRegistrasi: async(data) => {
        let uri = '/users/daftar';
        let url = process.env.REACT_APP_API_URL + uri;
        let token = localStorage.getItem('token') || '';

        let headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        
        let store = await axios.post(`${url}`, data, {headers});
        return store;
    },
    getDaftarToken: async() => {
        let uri = '/users/daftar';
        let url = process.env.REACT_APP_API_URL + uri;

        let tokenDaftar = await axios.get(`${url}`)
        return tokenDaftar
    }
}

export default service